export function toFixedFloor(value: number, digits: number = 2): number {
  const factor = Math.pow(10, digits);
  return Math.floor(value * factor) / factor;
}

export function int16ToUint8(value: number, minHU: number, maxHU: number) {
  if (value === -2048) {
    return 0; // 또는 NaN / 특별 코드로 마킹 가능
  }
  const clamped = Math.min(Math.max(value, minHU), maxHU);
  return ((clamped - minHU) / (maxHU - minHU)) * 255.0;
}

export function applyMyoCardialConfig(config: any, data: any) {
  if (!data) return;
  const myoCardial = data['MyoCardial'];
  const territory = data['Territory'];
  const { mass_area, vm_area, volume_area } = myoCardial;
  const totalMass = mass_area[0];
  Object.assign(config, {
    territory_branchid: territory.branchid,
    territory_input_idx: territory.input_idx,
    total: {
      volume: toFixedFloor(volume_area[0]),
      lvMass: toFixedFloor(totalMass),
      vmRatio: toFixedFloor(vm_area[0]),
    },
    dist: {
      rca: {
        mass: toFixedFloor(mass_area[1]),
        pct: toFixedFloor((mass_area[1] / totalMass) * 100),
      },
      lad: {
        mass: toFixedFloor(mass_area[2]),
        pct: toFixedFloor((mass_area[2] / totalMass) * 100),
      },
      lcx: {
        mass: toFixedFloor(mass_area[3]),
        pct: toFixedFloor((mass_area[3] / totalMass) * 100),
      },
    },
    risk: {
      volume: toFixedFloor(volume_area[4]),
      lvMass: {
        mass: toFixedFloor(mass_area[4]),
        pct: toFixedFloor((mass_area[4] / totalMass) * 100),
      },
      vmRatio: toFixedFloor(vm_area[4]),
    },
  });
}

export function zResize(
  src: Uint8Array,
  xSize: number,
  ySize: number,
  zSize: number,
  targetSize: number,
): Uint8Array {
  if (zSize === targetSize) return src;
  const dst = new Uint8Array(xSize * ySize * targetSize);

  const sliceSize = xSize * ySize;
  const zScale = (zSize - 1) / (targetSize - 1);

  for (let z = 0; z < targetSize; ++z) {
    const pos = z * zScale;
    const low = pos | 0;

    let high = low + 1;

    const lowRatioValue = ((high - pos) * 32768) | 0;

    const highRatioValue = 32768 - lowRatioValue;

    if (high >= zSize) {
      high = zSize - 1;
    }

    const lowOffset = low * sliceSize;

    const highOffset = high * sliceSize;

    let dstOffset = z * sliceSize;

    for (let i = 0; i < sliceSize; ++i) {
      const a = (src[lowOffset + i] << 1) + 1;
      const b = (src[highOffset + i] << 1) + 1;
      dst[dstOffset++] = (a * lowRatioValue + b * highRatioValue) >> 16;
    }
  }
  return dst;
}

export function printValueCounts(data: Uint16Array | Uint8Array | Uint32Array) {
  const counts = new Map<number, number>();

  for (const value of data) {
    counts.set(value, (counts.get(value) ?? 0) + 1);
  }

  console.table(
    [...counts.entries()]
      .sort((a, b) => a[0] - b[0])
      .map(([value, count]) => ({ value, count }))
  );
}
